import {
  INCIDENT_FORM_LIST_FAIL,
  INCIDENT_FORM_LIST_SUCCESS,
  UPLOAD_INCIDENT_FORM_SUCCESS,
  UPLOAD_INCIDENT_FORM_FAIL,
  UPDATE_INCIDENT_FORM_SUCCESS,
  UPDATE_INCIDENT_FORM_FAIL,
  GET_ADDED_QUESTIONS_SUCCESS,
  GET_ADDED_QUESTIONS_FAIL,
  DELETE_INCIDENT_QUESTION_SUCCESS,
  DELETE_INCIDENT_QUESTION_FAIL,
  UPDATE_INCIDENT_FORM_QUES_SUCCESS,
  UPDATE_INCIDENT_FORM_QUES_FAIL,
  EDIT_INICIDENT_FORM_ADMIN_SUCCESS,
  EDIT_INICIDENT_FORM_ADMIN_FAIL,
  SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS,
  SUBMIT_ADMIN_REVIEWD_FORM_FAIL,
  GET_ALL_INCIDENT_FORM_DATA_SUCCESS,
  GET_ALL_INCIDENT_FORM_DATA_FAIL,
  GET_OLD_INCIDENT_FORMS_SUCCESS,
  GET_OLD_INCIDENT_FORMS_FAIL,
  SEND_MAIL_SUCCESS,
  SEND_MAIL_FAIL,
  INCIDENT_LOGS_SUCCESS,
  INCIDENT_LOGS_FAIL,
  ARRANGE_INICIDENT_QUES_ORDER_SUCCESS,
  ARRANGE_INICIDENT_QUES_ORDER_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  list: [],
  pagination: {},
  editQuestionList: [],
  error: [],
  res: [],
  deleteRes: [],
  addedQuestions: [],
  adminSubmitedRes: [],
  IncidentFormData: [],
  oldFormsList: [],
  loading: false,
  logs: [],
};

const Register = (state = INIT_STATE, action) => {
  switch (action.type) {
    case INCIDENT_LOGS_SUCCESS:
      return {
        ...state,
        logs: action.payload,
        loading: false,
      };
    case INCIDENT_LOGS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case ARRANGE_INICIDENT_QUES_ORDER_SUCCESS:
      return {
        ...state,
        res: action.payload,
      };
    case ARRANGE_INICIDENT_QUES_ORDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SEND_MAIL_SUCCESS:
      return {
        ...state,
        res: action.payload,
        loading: false,
      };
    case SEND_MAIL_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_OLD_INCIDENT_FORMS_SUCCESS:
      return {
        ...state,
        oldFormsList: action.payload,
        loading: false,
      };
    case GET_OLD_INCIDENT_FORMS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_ALL_INCIDENT_FORM_DATA_SUCCESS:
      return {
        ...state,
        IncidentFormData: action.payload,
        loading: false,
      };
    case GET_ALL_INCIDENT_FORM_DATA_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case SUBMIT_ADMIN_REVIEWD_FORM_SUCCESS:
      return {
        ...state,
        adminSubmitedRes: action.payload,
        loading: false,
      };
    case SUBMIT_ADMIN_REVIEWD_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case EDIT_INICIDENT_FORM_ADMIN_SUCCESS:
      return {
        ...state,
        editQuestionList: action.payload,
        loading: false,
      };
    case EDIT_INICIDENT_FORM_ADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_INCIDENT_FORM_QUES_SUCCESS:
      return {
        ...state,
        res: action.payload,
        loading: false,
      };
    case UPDATE_INCIDENT_FORM_QUES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case DELETE_INCIDENT_QUESTION_SUCCESS:
      return {
        ...state,
        deleteRes: action.payload,
        loading: false,
      };
    case DELETE_INCIDENT_QUESTION_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_ADDED_QUESTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        addedQuestions: action.payload,
      };
    case GET_ADDED_QUESTIONS_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPDATE_INCIDENT_FORM_SUCCESS:
      return {
        ...state,
        res: action.payload,
        loading: false,
      };
    case UPDATE_INCIDENT_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case UPLOAD_INCIDENT_FORM_SUCCESS:
      return {
        ...state,
        res: action.payload,
        loading: false,
      };
    case UPLOAD_INCIDENT_FORM_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case INCIDENT_FORM_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.forms || [], // array
        pagination: action.payload.pagination || {},
        loading: false,
      };
    case INCIDENT_FORM_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return {
        ...state,
        error: [],
        loading: true,
      };
  }
};

export default Register;
